import { useQuery } from "@tanstack/react-query";
import { adminService } from "../services/admin.service";

export function useDatasources() {
  return useQuery({
    queryKey: ["admin-datasources"],
    queryFn: () => adminService.listDatasources(),
  });
}
